<template>
  <div class="is-flex mb-4">
    <img :src="imageUrl" alt="" class="partner-logo" />
    <div class="ml-4">
      <p class="has-text-weight-medium mb-0">{{ partner }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PartnerLogo",
  props: {
    offerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      imageUrl: null,
      partner: "",
    };
  },
  computed: {
    ...mapGetters({
      fileGetter: "drawer/getFile",
      getImageDetailsForOffer: "image/getImageDetailsForOffer",
    }),
  },
  async mounted() {
    await this.fetchImage();
    const { logo, partner } = this.getImageDetailsForOffer(this.offerId);
    this.partner = partner;

    if (!this.fileGetter(logo)) {
      await this.fetchFile(logo);
    }

    this.imageUrl = URL.createObjectURL(this.fileGetter(logo));
  },
  methods: {
    ...mapActions({
      fetchImage: "image/fetchImage",
      fetchFile: "drawer/download",
    }),
  },
};
</script>

<style scoped lang="scss">
.partner-logo {
  height: 24px;
}

@media only screen and (min-width: 1024px) {
  .partner-logo {
    height: 30px;
  }
}
</style>
